import React, { FC } from 'react';
import {
  GlossaryTermList,
  GlossarySubTitle,
  GlossaryListItem,
  GlossaryTermListLink,
  GlossaryTermListItem,
} from 'components/Glossary/Glossary.style';
import GlossaryLoader from 'components/utility/ContentLoader/GlossaryLoader/GlossaryLoader';
import { GlossaryData, Topic } from './BrowseGlossary.types';

interface IGlossaryContent {
  data: GlossaryData[];
  modal: boolean;
}

interface IRenderTopics {
  category: string;
  topics: Topic[];
  modal: boolean;
}

/** renderTopics renders the links in each group of links in the Glossary */
const RenderTopics: FC<IRenderTopics> = ({ category, topics, modal }) => {
  return (
    <GlossaryTermList>
      {topics.map((topic) => (
        <GlossaryTermListItem key={topic.slug}>
          <GlossaryTermListLink
            to={{
              pathname: `/glossary/${category}/${topic.slug}`,
              state: {
                modal,
              },
            }}
          >
            {topic.name}
          </GlossaryTermListLink>
        </GlossaryTermListItem>
      ))}
    </GlossaryTermList>
  );
};

/** renderGroups renders groups of links to GlossaryTerm pages */
const RenderGroups: FC<IGlossaryContent> = ({ data, modal }) => {
  return (
    <ul>
      {data ? (
        data.map((item) => {
          return (
            <GlossaryListItem key={item.name}>
              <GlossarySubTitle>{item.name}</GlossarySubTitle>
              {item.topics && (
                <RenderTopics
                  category={item.slug}
                  topics={item.topics}
                  modal={modal}
                />
              )}
            </GlossaryListItem>
          );
        })
      ) : (
        <GlossaryListItem>
          <GlossaryLoader />
        </GlossaryListItem>
      )}
    </ul>
  );
};

const GlossaryContent: FC<IGlossaryContent> = ({ data, modal }) => {
  return <RenderGroups data={data} modal={modal} />;
};

export default GlossaryContent;
